// @flow
import styled from 'styled-components';

export const InputContainer = styled.div`
    clear: both;
    margin-bottom: 0.5rem;
    position: relative;
    width: 100%;
`;

export const LabelField = styled.label`
    position: ${props => (props.showLabel ? 'static' : 'absolute')};
    clip: ${props => (props.showLabel ? 'inital' : 'rect(1px, 1px, 1px, 1px)')};
`;

const showError = props => (props.error && props.touched) || (props.serverError && !props.touched);

export const InputField = styled.input`
    border: none;
    height: 3rem;
    margin-bottom: 0.1rem;
    padding: 0 1rem;
    transition: border-bottom-color 0.3s;
    border: 1px solid ${props => (showError(props) ? props.theme.error : props.theme.mediumGrey)};
    width: 100%;
    border-radius: 2px;

    &:focus {
        border-color: ${({ theme }) => theme.grey};
        outline: none;
    }
`;

export const InputValidation = styled.div`
    color: ${({ theme }) => theme.error};
    float: right;
    font-weight: 500;
    margin-bottom: 0.5rem;
    margin-top: 0.25rem;
    opacity: ${props => (showError(props) ? '1' : '0')};
    text-align: right;
    transition: opacity 0.3s;
    width: 100%;
    height: ${props => (showError(props) ? '1.2rem' : '0')};
`;



// WEBPACK FOOTER //
// ./src/components/widgets/input/styles.js